export default __webpack_public_path__ + "static/media/guide_bg_top.fca5658b.png";